// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "* {\n  outline: none;\n}\n\n.borderInput {\n  background: linear-gradient(0deg, #fce8c0 0%, #fad492 100%);\n}\n", ""]);
// Exports
module.exports = exports;
